/** Full screen, where the browser allows it. Failing is fine: the kiosk still works. */

export function enterFullscreen(): void {
  if (!document.fullscreenElement) {
    void document.documentElement.requestFullscreen?.().catch(() => {})
  }
}

export function exitFullscreen(): void {
  if (document.fullscreenElement) void document.exitFullscreen?.().catch(() => {})
}
